module.exports = __webpack_public_path__ + "static/media/BlueButtonWithRad.8619747a.svg";